<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    height="500px"
    title="修改登录密码"
  >
    <el-row type="flex" class="tips"
      >您当前的账号是初始化默认密码，请设置新密码</el-row
    >
    <el-row type="flex">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="100px"
        class="form"
        style="width: 100%"
      >
        <el-form-item prop="oldPwd" label="旧密码">
          <el-input 
          v-model="form.oldPwd" 
          :type="form.showOldPwd ? 'text' : 'password'"
          placeholder="请输入旧密码">
            <template #append>
              <i class="icon-pwd" @click="form.showOldPwd = !form.showOldPwd"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="newPwd" label="新密码">
          <el-input 
          v-model="form.newPwd" 
          :type="form.showNewPwd ? 'text' : 'password'"
          placeholder="请输入新密码">
            <template #append>
              <i class="icon-pwd" @click="form.showNewPwd = !form.showNewPwd"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPwd" label="确认密码">
          <el-input 
          v-model="form.confirmPwd" 
          :type="form.showConfirmPwd ? 'text' : 'password'"
          placeholder="请输入确认密码">
            <template #append>
              <i class="icon-pwd" @click="form.showConfirmPwd = !form.showConfirmPwd"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="handleSubmit" class="btn"
        >确认</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import { editPasswordRules as rules } from "@/utils/validator";
import base64 from "@/utils/base64";
import cryptoJS from "@/utils/crypto-js";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
        showOldPwd: false,
        showNewPwd: false,
        showConfirmPwd: false,
      },
      rules,
    };
  },

  watch: {
    visible() {
      this.$refs.form?.resetFields();
    },
  },

  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        let {
          oldPwd,
          newPwd,
          confirmPwd,
        } = this.form;
        let { success, msg } = await this.$api.updatePassword({
          oldPassword:cryptoJS.encrypt(new base64().encode(oldPwd)),
          newPassword:cryptoJS.encrypt(new base64().encode(newPwd)),
          surePassword:cryptoJS.encrypt(new base64().encode(confirmPwd)),
          });
        if (success) {
          this.$message.success(msg);
          this.close(); // 修改密码后关闭dialog
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 关闭dialog
    close() {
      this.$store.commit("user/SET_PWD_STATUS", "changed");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  .el-dialog__header {
    padding-bottom: 22px;
    .el-dialog__title {
      color: #000;
      font-weight: 600;
    }
    .el-dialog__headerbtn {
      .el-dialog__close {
        &::before {
          @extend .f18;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0 30px 41px;
    .el-form {
      &-login {
        .el-input__inner {
          padding-left: 0;
        }
      }
      .el-form-item__label {
        @extend .f18;
        color: #323233;
      }
      .el-form-item__content {
        .el-input-group__prepend,
        .el-input-group__append {
          border: none;
        }
        .el-select {
          width: 76px;
          color: #000;
        }
        .el-input__inner {
          @extend .f18;
          color: #000;
          border: none;
        }
        .el-input-group__prepend {
          &::after {
            content: "";
            display: inline-block;
            position: relative;
            left: 20px;
            width: 1px;
            height: 27px;
            background: #ebeef5;
            vertical-align: middle;
          }
        }
        .btn-send-code {
          padding: 0;
          width: 90px;
          height: 32px;
          border-radius: 5px;
          color: #409eff;
          border: 1px solid #409eff;
        }
      }
    }
  }
}
.icon-pwd {
          &::after {
            content: "";
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url("~@/assets/icon/hide.png") center/100% no-repeat;
            cursor: pointer;
          }
        }
.tips {
  margin-bottom: 20px;
  color: #323233;
}
.text {
  color: #323233;
  &-register {
    margin: 41px 0 40px;
  }
  &-login {
    margin: 16px 0 40px;
    .btn-register {
      padding: 0;
      @extend .f18;
      line-height: 1;
    }
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: initial;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  &-hyperlink {
    margin-bottom: 40px;
    color: #409eff;
  }
}
.btn {
  width: 429px;
  height: 48px;
  background: #1890ff;
  border-radius: $border-radius;
}
</style>
